<template>
    <div>
        <table class="table-view margin-top-20">
            <thead class="head-show">
                <tr style="text-align: center;">
                    <th v-for="settingsItem of reportColumnsSettings">
                        <span>{{settingsItem.caption}}</span>
                        <span class="margin-left-5 table-view-head-desc" v-if="settingsItem.description">
                            <i class="fa fa-info-circle" :title="settingsItem.description"></i>
                        </span>
                    </th>
                    <th v-if="!bonusSettings.noReport">Сумма баллов</th>
                    <th v-if="canBeEdited"></th>
                </tr>
            </thead>
            <tbody>
            <template v-if="reportItemsInfo != null">
                <tr class="total">
                    <td v-for="(item, i) of reportColumnsSettings">
                        <span v-if="i === 0">Итого:</span>
                        {{ reportItemsInfo[item.name] }}
                    </td>
                    <td>
                        {{ reportItemsInfo.BonusAmount }}
                    </td>
                </tr>
            </template>
            <tr v-for="(item, i) of reportItems">
                <td v-for="settingsItem of reportColumnsSettings" :class="getStyle(settingsItem)">
                    <template v-if="canBeEdited">
                        <template v-for="(field, j) of item.Fields">
                            <template v-if="settingsItem.name === field.Name && settingsItem.type === 'int'">
                                <touch-spin v-model.number="field.Value" @input="onItemChange" v-validate="{ rules: { required: true} }" :name="field.Name + i"></touch-spin>
                            </template>
                            <template v-if="settingsItem.name === field.Name && settingsItem.type === 'decimal'">
                                <touch-spin v-model.number="field.Value" @input="onItemChange" v-validate="{ rules: { required: true} }" :name="field.Name + i"
                                            :decimals="2" :step="0.01"></touch-spin>
                            </template>
                            <template v-if="settingsItem.name === field.Name && settingsItem.type === 'string'">
                                <input type="text" :name="field.Name + i"
                                       v-model="field.Value"
                                       v-validate="{ rules: { required: true} }"
                                       :class="['input-text', {'input-error': errors.has(field.Name + i)}]"
                                       @input="onItemChange"
                                       autocomplete="off" />
                            </template>
                            <template v-if="settingsItem.name === field.Name && settingsItem.type === 'bool'">
                                <input :id="'field_' + j + '_row' + i" v-model="field.Value" value="true" type="checkbox" class="input-checkbox" @input="onItemChange" autocomplete="off" />
                                <label :for="'field_' + j + '_row' + i" class="input-checkbox-lbl no-text" @click.stop=""></label>
                                <!--<input type="checkbox" class="input-text" v-model="field.Value" @input="onItemChange" autocomplete="off" />-->
                            </template>
                            <template v-if="settingsItem.name === field.Name && settingsItem.type === 'select'">
                                <drop-down :name="settingsItem.name + '' + i"
                                           :items="getSelectItems(item, settingsItem)"
                                           v-model="field.Value"
                                           :dataField="'Id'"
                                           :textField="'Name'"
                                           :withSelectItem="'true'"
                                           @input="onItemChange"></drop-down>

                            </template>
                            <template v-if="settingsItem.name === field.Name && settingsItem.type === 'sku'">
                                <search-filter :name="field.Name + i"
                                               v-validate="{ rules: { required: true} }"
                                               :hasErrors="errors.has(field.Name + i)"
                                               :extra="i"
                                               :placeholder="(settingsItem.placeholder || 'Выберите sku')"
                                               :searchFunction="searchSkuFunction"
                                               :selectedItem="getSkuSelectedItem(field)"
                                               :searchOnSelect="true"
                                               :scrollable="true"
                                               :fieldName="field.Name"
                                               @onFilterChange="onChangeSkuSearch(...arguments, field.Name)"></search-filter>
                            </template>
                            <template v-if="settingsItem.name === field.Name && settingsItem.type === 'date'">
                                <input-date :name="field.Name + i"
                                            :withMask="true"
                                            v-validate="{ rules: { required: true} }"
                                            v-model="field.Value"
                                            @input="onItemChange"
                                            :todayHighlight="bonusSettings.noReport"
                                            :class="['input-date', {'input-error': errors.has(field.Name + i)}]"></input-date>
                            </template>
                        </template>
                    </template>
                    <template v-if="!canBeEdited && !isNewAnswer">
                        <span v-for="field of item.Fields" :key="`readonly-${field.Name}-${item.Id || i}`" v-if="settingsItem.name === field.Name">
                            {{ field.Title ? field.Title: field.Value }}
                        </span>
                    </template>
                </td>
                <td v-if="!bonusSettings.noReport" class="value">
                    <template v-if="bonusSettings.bonusStrategy.type !== 'fact'">
                        {{ getBonusAmount(item) }}
                    </template>
                </td>
                <td v-if="canBeEdited" class="obtn-short">
                    <button type="button" class="btn btn-default btn-img" @click="removeItem(item, i)">
                        <img src="../../img/icon-del.png" alt="" />
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
        <button type="button" class="btn btn-primary margin-top-10" @click="addItem()" v-if="canBeEdited && (maxItems === 0 || (reportItems.length < maxItems))">
            Добавить запись
        </button>
    </div>
</template>

<script>
    import _ from 'lodash'
    import BackendApi from '../backendApi'
    import {BonusStrategyAccrualTypes} from '../enums'
    import moment from 'moment'

    let backendApi = new BackendApi();

    export default {
        name: "report-items-table",

        props: ['bonusSettings', 'value', 'reportSettings', 'sku', 'equipmentTypes', 'canBeEdited', 'tradePoint', 'minItems', 'maxItems', 'dateToBonus', 'skuBonusList', 'isNewAnswer'],

        data(){
            return{
                reportItems: [],
                localReportSettings: []
            }
        },

        watch: {
            reportItems: function () {
                this.$emit('input', this.getExportData());
            },
        },

        computed:{
            reportItemsInfo: function () {
                let vm = this;
                if (vm.bonusSettings.noReport)
                    return null;

                let sumObj = {
                    BonusAmount: 0
                };

                for (let item of this.reportItems) {
                    for (let sItem of this.localReportSettings) {
                        if (sItem.sumUp) {
                            if (!sumObj[sItem.name]) {
                                sumObj[sItem.name] = 0;
                            }

                            for (let field of item.Fields) {
                                if (field.Name === sItem.name && field.Value !== '') {
                                    sumObj[sItem.name] += field.Value;
                                }
                            }
                        }
                    }

                    // считаем баллы по позиции
                    if(vm.bonusSettings.bonusStrategy.type !== 'fact') {
                        sumObj.BonusAmount += vm.getBonusAmount(item);
                    }
                }

                if(this.reportItems.length && vm.bonusSettings.bonusStrategy.type === 'fact') {
                    sumObj.BonusAmount += vm.getBonusAmount();
                }

                return sumObj;
            },

            reportColumnsSettings: function () {
                return this.localReportSettings.filter((item) => {
                    return !item.deleted;
                });
            }
        },

        methods: {
          logFieldData(field) {
                  console.log(field);
              },
            getStyle(sett) {
                let css = "";
                switch (sett.type){
                    case "int": css = "value-big"; break;
                    case "decimal": css = "value-big"; break;
                    case "string": css = "string"; break;
                    case "bool": css = "bit"; break;
                    case "select": css = "string"; break;
                    case "sku": css = "string"; break;
                    case "date": css = "datetime"; break;
                }
                return css;
            },
          getBonusAmount(item) {
            if (!this.bonusSettings || !this.bonusSettings.bonusStrategy) {
              return 0;
            }

            let bonusAmount = 0;
            const strategy = this.bonusSettings.bonusStrategy;

            switch (strategy.type) {
              case 'sku':
                bonusAmount = this.calculateSkuBonus(item, strategy);
                break;

              case 'fact':
                bonusAmount = parseFloat(strategy.data.value);
                break;

              case 'data':
                bonusAmount = this.calculateDataBonus(item, strategy);
                break;

              case 'percent':
                bonusAmount = this.calculatePercentBonus(item, strategy);
                break;

              case 'perSku':
                bonusAmount = this.calculatePerSkuBonus(item, strategy);
                break;

              default:
                console.error(`Unknown strategy type: ${strategy.type}`);
                break;
            }

            return Math.round(bonusAmount * 100) / 100;
          },
          getFieldValue(item, fieldName) {
            const field = item.Fields.find(x => x.Name === fieldName);
            return field ? parseFloat(field.Value) : 0;
          },

          calculateSkuBonus(item, strategy) {
            if (item.BonusAmount) {
              return item.BonusAmount;
            }
            const countFieldValue = this.getFieldValue(item, strategy.data.countFieldName);
            const count = strategy.data.bonusType === 'percent' ? countFieldValue / 100 : parseInt(countFieldValue, 10);
            const skuId = parseInt(this.getFieldValue(item, strategy.data.fieldName), 10);
            const skuItem = this.sku.find(x => x.Id === skuId);
            let bonusAmount = 0;

            if (skuItem) {
              const skuLinkItem = skuItem.SkuLink.find(x => x.Name === this.tradePoint.SkuLink);
              if (skuLinkItem) {
                bonusAmount = skuLinkItem.Amount * count;
                let reportDate = this.dateToBonus.reportDate ? moment(this.dateToBonus.reportDate, 'DD.MM.YYYY') : moment();

                if (strategy.data.reportDateType === 'selldate') {
                  const fieldVal = this.getFieldValue(item, strategy.data.reportSellDateFieldName);
                  reportDate = moment(fieldVal, 'DD.MM.YYYY');
                }

                const period = _.find(skuLinkItem.SkuLinkPeriod, el => moment(el.DateStart) <= reportDate && (!el.DateEnd || moment(el.DateEnd) >= reportDate));
                if (period) {
                  bonusAmount = period.Amount * count;
                }
              }
            }

            return bonusAmount;
          },

          calculateDataBonus(item, strategy) {
            const baseFieldValue = this.getFieldValue(item, strategy.data.fieldName);
            let multiplier = parseFloat(strategy.data.value);
            let date;

            if (strategy.data.accrualType == BonusStrategyAccrualTypes.SumPercent) {
              switch (strategy.data.accrualValueDate) {
                case 'none':
                  break;
                case 'dateCreate':
                  date = this.dateToBonus.createDate ? moment(this.dateToBonus.createDate, 'DD.MM.YYYY') : moment();
                  break;
                case 'dateAccept':
                  date = this.dateToBonus.approvementDate ? moment(this.dateToBonus.approvementDate, 'DD.MM.YYYY') : moment();
                  break;
                case 'dateReport':
                  date = this.dateToBonus.reportDate ? moment(this.dateToBonus.reportDate, 'DD.MM.YYYY') : moment();
                  break;
                default:
                  const field = item.Fields.find(x => x.Name === strategy.data.accrualValueDate);
                  if (field) {
                    date = moment(field.Value, 'DD.MM.YYYY');
                  }
                  break;
              }

              if (date) {
                const period = _.find(strategy.data.dateBonusItems, el => el.dateBeg <= date && el.dateEnd >= date);
                if (period) {
                  multiplier = parseFloat(period.value);
                }
              }
              multiplier /= 100.0;
            }

            return baseFieldValue * multiplier;
          },

          calculatePercentBonus(item, strategy) {
            const fieldIndex = this.localReportSettings.findIndex(x => x.id === strategy.data.fieldId);
            if (fieldIndex === -1) return 0;

            const field = item.Fields[fieldIndex];
            const baseFieldValue = field ? parseFloat(field.Value) : 0;
            const multiplier = parseFloat(strategy.data.value);

            return baseFieldValue * multiplier / 100;
          },

          calculatePerSkuBonus(item, strategy) {
            const countFieldIndex = this.localReportSettings.findIndex(x => x.id === strategy.data.fieldId);
            if (countFieldIndex === -1) return 0;

            const countField = item.Fields[countFieldIndex];
            const count = countField ? parseFloat(countField.Value) : 0;

            const skuFieldIndex = this.localReportSettings.findIndex(x => x.type === 'sku');
            if (skuFieldIndex === -1) return 0;

            const skuField = item.Fields[skuFieldIndex];
            const skuId = skuField ? skuField.Value : null;

            const bonus = this.skuBonusList.find(x => x.SkuId === skuId);
            const bonusValue = bonus ? bonus.Bonus : 0;


            return isNaN(count) ? 0 : count * bonusValue;
          },

            onItemChange(){
                this.$emit('input', this.getExportData());
            },

            getSkuSelectedItem(field) {
                return {
                    Id: field.Value,
                    Name: field.Title
                }
            },

            searchSkuFunction(searchText, callback, extra, page, fieldName) {
                let vm = this;
                //console.info('searchSkuFunction', searchText, callback, extra, page, fieldName);
                if (vm.bonusSettings.skuView === 'tasks') {
                    let colSetting = this.localReportSettings.find(x => { return x.name === fieldName });
                    //console.info('searchSkuFunction', field, colSetting, fieldName);
                    //if ((page - 1) === 0) callback(vm.sku);
                    vm.callApiWrapper(backendApi.skuSearchForTable((page - 1) * 20, 20, vm.tradePoint.Id, searchText, fieldName, colSetting.id, vm.bonusSettings.skuView))
                        .then(function (resp) {
                            callback(resp.data);
                        });
                }
                else {
                    let field = this.reportItems[extra].Fields.find(x => { return x.Type === 'sku' });
                    vm.callApiWrapper(backendApi.skuSearch((page - 1) * 20, 20, vm.tradePoint.Id, searchText, field.Name))
                        .then(function (resp) {
                            callback(resp.data);
                        });
                }
            },

            onChangeSkuSearch(listItem, extra, fieldName) {
                let field = this.reportItems[extra].Fields.find( x => { return  x.Type === 'sku' && x.Name === fieldName});
                field.Value = listItem ? listItem.Id : null;
                field.Title = listItem ? listItem.Name : field.Title;
            },

            addItem() {
                let vm = this;
                let newItem = { Id: 0, Fields: [] };

                // Если это массив Vue с реактивной оберткой
                    for (let settingsItem of this.localReportSettings) {

                        if (!settingsItem.deleted) {
                            let newField = { Name: settingsItem.name, Value: null, Type: null, Title: null };
                            newField.Type = settingsItem.type;

                            if (settingsItem.type === 'bool') {
                                newField.Value = false;
                            } else if (settingsItem.type === 'int' || settingsItem.type === 'decimal') {
                                newField.Value = 0;
                            }

                            if (settingsItem.name === 'EquipmentType') {
                                if (!vm.equipmentTypes.length) {
                                    console.error('Не загружены справочники');
                                    return;
                                }
                                newField.Value = vm.equipmentTypes[0].Id;
                            }

                            newItem.Fields.push(newField);
                        }
                    }
                    this.reportItems.push(newItem);
            },

            getExportData(){
                return this.reportItems;
            },

            removeItem(item, index) {
                let vm = this;
                if(vm.localReportSettings[0].type === 'sku') {
                    this.$nextTick(() => {
                        vm.reportItems.splice(index, 1);
                    });
                } else {
                    // пока непонятно что не обновляется. чистится sku у предыдущих новых строк
                    let name = vm.localReportSettings[0].name;
                    vm.localReportSettings[0].name = 'as';
                    this.$nextTick(() => {
                        vm.reportItems.splice(index, 1);
                        vm.localReportSettings[0].name = name;
                    });
                }
                //без этих телодвижений, строки в таблице не обновляются
            },

            getSelectItems(item, settingsItem){
                let vm = this;

                if(settingsItem.options && settingsItem.options.length){
                    let mapped = _.map(JSON.parse(settingsItem.options), (itm) => {
                        return {
                            Id: itm,
                            Name: itm,
                            Selected: false
                        }
                    });

                    return mapped;
                }
                // если в options ничего не указано - ищем зарезервированные поля (Sku/Type)
                if(settingsItem.name === 'EquipmentType') {
                    let data = [];
                    for(let i of vm.equipmentTypes)
                    {
                        data.push({
                            Id: i.Id,
                            Name: i.Name
                        });
                    }
                    return data;
                }
                // if(settingsItem.name === 'SkuId') {
                //     let data = [];
                //     for(let i of vm.sku)
                //     {
                //         data.push({
                //             Id: i.Id,
                //             Name: i.Name
                //         });
                //     }
                //     return data;
                // }

                return [];
            },

            validate(){
                return this.$validator.validate();
            },

            importItems(items){
                if(items && items.length){
                    for(let item of items) {
                        this.reportItems.push(item);
                    }
                }
            },

            reportItemsTable_Init() {
                let vm = this;
                if (vm.canBeEdited && vm.value.length === 0) {
                    for (let i = 0; i < vm.minItems; ++i) {
                        vm.addItem();
                    }
                }
            }
        },

        mounted(){
          this.reportItems = this.value;
          this.localReportSettings = this.reportSettings
          if (this.isNewAnswer) {
              setTimeout(() => {
                this.reportItemsTable_Init();
              }, 250);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Content/src/components/ReportItemsTable.vue